export default class {
	constructor(options) {
		this.defaults = {
			$el: null,
			buffer: 6,
		};
		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = "CHIPS_RangeSlider";
		if (this.options.$el) {
			this.$el = this.options.$el;
			this.init(true);
		}

		this.valMin = 0;
		this.valMax = 0;
		this.labelFormat = null;

		this.lastControlled = null;
		this.currControlled = null;
	}

	init(bool) {
		if (bool) {
			if (this.$el.dataset.minval) {
				this.valMin = this.$el.dataset.minval;
			} else {
				this.valMin = 1970;
			}

			if (this.$el.dataset.maxval) {
				this.valMax = this.$el.dataset.maxval;
			} else {
				this.valMax = 0;
			}

			this.fromSlider = this.$el.querySelector(".slider__single--min");
			this.toSlider = this.$el.querySelector(".slider__single--max");
			this.fromInput = this.$el.querySelector(".filter--min");
			this.toInput = this.$el.querySelector(".filter--max");
			this.fromLabel = this.$el.querySelector(".filter--min-label");
			this.toLabel = this.$el.querySelector(".filter--max-label");

			// console.log(this.fromInput, this.toInput);

			if (this.$el.classList.contains("filter__sliders--size")) {
				this.labelFormat = "number";
				this.options.buffer = 20000;
			} else if (
				this.$el.classList.contains("filter__sliders--location")
			) {
				this.labelFormat = "custom_location";
				this.options.buffer = 1;
			} else {
				this.labelFormat = "standard";
			}

			this.fillSlider(
				this.fromSlider,
				this.toSlider,
				"#DBDBDB",
				"#2C2C2C",
				this.toSlider
			);
			this.setToggleAccessible(this.toSlider);

			this.fromSlider.oninput = () =>
				this.controlFromSlider(
					this.fromSlider,
					this.toSlider,
					this.fromInput
				);
			this.toSlider.oninput = () =>
				this.controlToSlider(
					this.fromSlider,
					this.toSlider,
					this.toInput
				);
			this.fromInput.oninput = () =>
				this.controlFromInput(
					this.fromSlider,
					this.fromInput,
					this.toInput,
					this.toSlider
				);
			this.toInput.oninput = () =>
				this.controlToInput(
					this.toSlider,
					this.fromInput,
					this.toInput,
					this.toSlider
				);

			// console.log(
			// 	this.fromSlider,
			// 	this.fromInput,
			// 	this.toInput,
			// 	this.toSlider
			// );

			// if this.fromSlider value == the max value, console.log("max value reached")
			if (this.fromSlider.value == this.fromSlider.max) {
				console.log("max value reached");
			}
			if (this.toSlider.value == this.toSlider.min) {
				this.$el.classList.add("min-reach");
			} else {
				this.$el.classList.remove("min-reach");
			}
			if (this.fromSlider.value == this.fromSlider.max) {
				this.$el.classList.add("max-reach");
			} else {
				this.$el.classList.remove("max-reach");
			}

			window.rangeFunctions.push(this);
		}
	}

	controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
		this.lastControlled = "from";
		const [from, to] = this.getParsed(fromInput, toInput);
		this.fillSlider(
			fromInput,
			toInput,
			"#DBDBDB",
			"#2C2C2C",
			controlSlider
		);
		if (from > to) {
			fromSlider.value = to;
			fromInput.value = to;
		} else {
			fromSlider.value = from;
		}
	}

	controlToInput(toSlider, fromInput, toInput, controlSlider) {
		this.lastControlled = "to";
		const [from, to] = this.getParsed(fromInput, toInput);
		this.fillSlider(
			fromInput,
			toInput,
			"#DBDBDB",
			"#2C2C2C",
			controlSlider
		);
		this.setToggleAccessible(toInput);
		if (from <= to) {
			toSlider.value = to;
			toInput.value = to;
		} else {
			toInput.value = from;
		}
	}

	controlFromSlider(fromSlider, toSlider, fromInput) {
		this.lastControlled = "from";
		const [from, to] = this.getParsed(fromSlider, toSlider);
		const buffer = this.options.buffer;

		if (from + buffer > to) {
			fromSlider.value = to - buffer;
			fromInput.value = to - buffer;
		} else {
			fromInput.value = from;
		}
		this.fillSlider(fromSlider, toSlider, "#DBDBDB", "#2C2C2C", toSlider);
	}
	
	controlToSlider(fromSlider, toSlider, toInput) {
		this.lastControlled = "to";
		const [from, to] = this.getParsed(fromSlider, toSlider);
		const buffer = this.options.buffer;

		if (to - buffer < from) {
			toSlider.value = from + buffer;
			toInput.value = from + buffer;
		} else {
			toInput.value = to;
		}
		this.fillSlider(fromSlider, toSlider, "#DBDBDB", "#2C2C2C", toSlider);
	}

	resetRange() {
		this.fromSlider.value = this.fromSlider.min;
		this.toSlider.value = this.toSlider.max;
		this.fromInput.value = this.fromSlider.min;
		this.toInput.value = this.toSlider.max;
		this.fillSlider(
			this.fromSlider,
			this.toSlider,
			"#DBDBDB",
			"#2C2C2C",
			this.toSlider
		);
	}

	getParsed(currentFrom, currentTo) {
		const from = parseInt(currentFrom.value, 10);
		const to = parseInt(currentTo.value, 10);
		return [from, to];
	}

	fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
		const rangeDistance = to.max - to.min;
		const fromPosition = from.value - to.min;
		const toPosition = to.value - to.min;

		if (this.toSlider.value == this.toSlider.min) {
			this.$el.classList.add("min-reach");
		} else {
			this.$el.classList.remove("min-reach");
		}
		if (this.fromSlider.value == this.fromSlider.max) {
			this.$el.classList.add("max-reach");
		} else {
			this.$el.classList.remove("max-reach");
		}

		// // don't let the from slider go past the to slider
		// if (fromPosition >= toPosition) {
		// 	from.value = to.value;
		// }

		controlSlider.style.background = `linear-gradient(
		  to right,
		  ${sliderColor} 0%,
		  ${sliderColor} ${(fromPosition / rangeDistance) * 100}%,
		  ${rangeColor} ${(fromPosition / rangeDistance) * 100}%,
		  ${rangeColor} ${(toPosition / rangeDistance) * 100}%, 
		  ${sliderColor} ${(toPosition / rangeDistance) * 100}%, 
		  ${sliderColor} 100%)`;

		this.$el.style.setProperty(
			"--min-left",
			`${(fromPosition / rangeDistance) * 100}%`
		);
		// set the innerHTML of .filter__date--min-label span to the value of from
		// console.log(this.labelFormat, from.value, to.value);
		let labelFrom = from.value;
		let labelTo = to.value;

		if (this.$el.classList.contains("filter__sliders--size")) {
			let tempFrom = parseInt(from.value, 10);
			let tempTo = parseInt(to.value, 10);

			if (tempFrom >= 100000) {
				tempFrom = "over " + this.formatNumber(tempFrom);
			} else if (tempFrom <= 1000) {
				tempFrom = "under " + this.formatNumber(tempFrom);
			} else {
				tempFrom = this.formatNumber(tempFrom);
			}
			if (tempTo >= 100000) {
				tempTo = "over " + this.formatNumber(tempTo);
			} else if (tempTo < 1000) {
				tempTo = "under " + this.formatNumber(tempTo);
			} else {
				tempTo = this.formatNumber(tempTo);
			}

			// if (tempFrom >= 100000 && tempFrom <= 500000) {
			// 	tempFrom = Math.round(tempFrom / 100000) * 100000;
			// }
			// if (tempTo >= 100000 && tempTo <= 500000) {
			// 	tempTo = Math.round(tempTo / 100000) * 100000;
			// }

			labelFrom = tempFrom;
			labelTo = tempTo;
		} else if (this.$el.classList.contains("filter__sliders--location")) {
			if (from.value === "0") {
				labelFrom = "Rural";
			} else if (from.value === "1") {
				labelFrom = "Suburban";
			} else if (from.value === "2") {
				labelFrom = "Town";
			} else if (from.value === "3") {
				labelFrom = "Urban";
			}
			if (to.value === "0") {
				labelTo = "Rural";
			} else if (to.value === "1") {
				labelTo = "Suburban";
			} else if (to.value === "2") {
				labelTo = "Town";
			} else if (to.value === "3") {
				labelTo = "Urban";
			}
		} else {
			labelFrom = from.value;
			labelTo = to.value;
		}
		this.$el.querySelector(".filter--min-label span").innerHTML = labelFrom;
		this.$el.querySelector(".filter--max-label span").innerHTML = labelTo;
		if (this.$el.querySelector(".filter_el--combined")) {
			this.$el.querySelector(".filter_el--combined").innerHTML =
				labelTo + "—" + labelFrom;
		}
		this.$el.style.setProperty(
			"--max-left",
			`${(toPosition / rangeDistance) * 100}%`
		);

		let parallelFrom = +from.value;
		let parallelTo = +to.value;

		if (parallelFrom >= parallelTo) {
			this.$el.classList.add("hide-min");
		} else {
			this.$el.classList.remove("hide-min");
		}

		if (this.lastControlled !== this.currControlled) {
			this.currControlled = this.lastControlled;
			if (this.lastControlled === "from") {
				this.$el.classList.remove("last-controlled-to");
				this.$el.classList.add("last-controlled-from");
			} else {
				this.$el.classList.remove("last-controlled-from");
				this.$el.classList.add("last-controlled-to");
			}
		}

		this.emitDataToParent();
	}

	formatNumber(number) {
		return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

	setToggleAccessible(currentTarget) {
		const toSlider = this.$el.querySelector(".slider__single--max");
		if (Number(currentTarget.value) <= 0) {
			this.toSlider.style.zIndex = 2;
		} else {
			this.toSlider.style.zIndex = 0;
		}
	}

	emitDataToParent() {
		const event = new CustomEvent("rangeChanged", {
			detail: {
				rangeEl: this.$el,
			},
		});
		this.$el.dispatchEvent(event);
	}

}
